// Donation-page header message normalization, matching the backend `DonationHeaderMessage`. Its length
// cap is generated into constants.gen.ts as DONATION_HEADER_MAX_LENGTH. The SERVER is the authoritative
// guardrail (it re-validates + persists); this is for client feedback.

/**
 * Normalize a raw header message for display / persistence: trim the ends, and collapse a blank
 * (empty or whitespace-only) message to `null` — the empty state that renders NO header at all.
 * Interior newlines are preserved (a multi-line appeal stays multi-line). Mirrors the normalization
 * half of the backend `DonationHeaderMessage.Validate` (trim + blank→null); it does NOT enforce the
 * length cap — the textarea `maxLength` and the server's `Validate` do that.
 */
export function normalizeDonationHeader(raw: string | null | undefined): string | null {
  const trimmed = (raw ?? '').trim();
  return trimmed.length > 0 ? trimmed : null;
}
